import React, { useCallback, useEffect, useMemo, useState } from "react"
import { calculateTotal, calculateTotalWeight, exportToExcel, exportToPDF, filterKeys } from "../../Utility/utility.js"
import { isMobile } from "react-device-detect"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    NextUITable,
} from "../../components"
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADEOF_CODE, ENUM_TRADEOF_LIST, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, getModVisiblity } from "../../constants/enum.js"
import { useSelector } from "react-redux"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import {
    COLUMN_ALIGN_TYPE,
    COLUMN_TYPE,
    FOOTER_TYPE,
} from "../../components/NextUITable.jsx"
import { faEllipsisVertical, faFilter, faFilterCircleXmark, faMagnifyingGlass, faRefresh, } from "@fortawesome/free-solid-svg-icons"
import { Button, Card, CardBody, RadioGroup, Radio, Select, SelectItem, } from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useParams } from "react-router-dom"
import { DataGrid, getGridNumericOperators, GridPagination, useGridApiContext } from "@mui/x-data-grid"
import { Box, FormControl, Chip, Checkbox, Autocomplete, ListItemText, MenuItem, OutlinedInput, TextField, Typography } from "@mui/material"
import { toast } from "react-toastify"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"

const isNumericColumn = (values) => {
    return values.every(v => !isNaN(parseFloat(v)) && isFinite(v));
};
const SortIconNone = () => <span className="text-blue-300" style={{ fontSize: "12px" }}>⇅</span>;
const SortIconAsc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▲</span>;
const SortIconDesc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▼</span>;
const RoughStock = () => {
    const { compCode, compName, startDate, endDate, } = useSelector((state) => state.company)
    const [selectedItem, setSelectedItem] = useState("")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selModName, setSelModName] = useState("")
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [modSettingParams, setModSettingParams] = useState("")
    const [mixStockParams, setMixStockParams] = useState("")
    const [stockType, setStockType] = useState("OnHand")
    const [selectFilter, setSelectFilter] = useState({});
    const [filterDate, setFilterDate] = useState({
        start: startDate ? startDate : null,
        end: endDate ? endDate : null
    })
    const [sortConfig, setSortConfig] = useState({ field: null, order: null });
    const { stype } = useParams()
    const SelectorIcon = (props) => {
        return (
            <svg
                aria-hidden="true"
                fill="currentColor"
                focusable="false"
                role="presentation"
                viewBox="0 0 24 24"
                width="0.5rem"
                height="0.5rem"
                {...props}
            >
                <path d="M3 4h18c.6 0 1 .5.8 1.1L15 12.5V20c0 .3-.2.6-.5.8l-4 2c-.5.2-1-.2-1-.8v-9.5L2.2 5.1C2 4.5 2.4 4 3 4z" />
            </svg>


        );
    };

    const RowsField = {
        id: "id",
        RoughCode: "Rgh_Code",
        RoughName: "Rgh_Name",
        RateD: "DRate",
        Rate: "Rate",
        InwCts: "RCts",
        SaleCts: "SalCts",
        RejCts: "RejCts",
        MixCts: "MixCts",
        FinalStock: "FinStk",
        BalStock: "BalStk",
        BalAmt: "BalAmtRs",
        BalAmtD: "BalAmtD",

    }

    const funFilterData = (fromdate, todate) => {

        filterStock({
            data: {
                compcode: compCode.join(","),
                fromdate: fromdate,
                todate: todate

            }
        })
    }

    const handleResetFilter = () => {
        setSelectedItem("")
        setFilterDate({ start: startDate, end: endDate })
        funFilterData(startDate, endDate)
    }
    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingStockItem",
    })
    useEffect(() => {
        funFilterData(filterDate.start, filterDate.end);
        filterModSetting({
            data: {
                mod_name: ENUM_MOD_NAME.GeneralSettings
            }
        })
    }, [])



    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {

            const generalData = modSetting
            let currency_setting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS
            setCurrencySetting(currency_setting)

        }
    }, [modSetting])
    const {
        data = [],
        isError,
        isPending,
        mutate: filterStock,
    } = usePost({
        url: apiRoute.stockEntry.fetchRoughStock,
        queryKey: "GetStock",
        onSuccessTasks: (data) => {
            // if (data && data.length > 0) {
            //     setRows(data)
            // }
        }

    })
    // const [rows, setRows] = useState([])

    const finalRows = useMemo(() => {
        let filtered = data.filter(item => {
            return Object.keys(selectFilter).every(field => {
                const selected = selectFilter[field];
                if (!selected?.length) return true;
                return selected.includes(![RowsField.RoughCode, RowsField.RoughName].includes(field) ? item[field] : String(item[field]));
            })
            // && Object.keys(debouncedSearch).every(field => {
            //   const s = debouncedSearch[field]?.toLowerCase() || "";
            //   return s ? String(item[field]).toLowerCase().includes(s) : true;
            // });
        });


        // if (searchTerm && searchTerm !== "") {
        //     const lowerSearch = searchTerm.toLowerCase();
        //     filtered = filtered.filter(item =>
        //         Object.values(item).some(value =>
        //             String(value).toLowerCase().includes(lowerSearch)
        //         )
        //     );
        // }

        if (sortConfig.field && sortConfig.order) {
            const field = sortConfig.field;
            const values = filtered.map(r => r[field]);
            const isNum = isNumericColumn(values);

            filtered = [...filtered].sort((a, b) => {
                const av = a[field];
                const bv = b[field];
                if (isNum) return sortConfig.order === "asc" ? av - bv : bv - av;
                return sortConfig.order === "asc"
                    ? String(av).localeCompare(String(bv))
                    : String(bv).localeCompare(String(av));
            });
        }

        return filtered;
    }, [data, selectFilter, sortConfig]);
    const totalStkAmtD = useMemo(
        () =>
            calculateTotal({
                data: finalRows,
                columnName: RowsField.BalAmtD,
            }),
        [finalRows]
    )
    const totalStkAmt = useMemo(
        () =>
            calculateTotal({
                data: finalRows,
                columnName: RowsField.BalAmt,
            }),
        [finalRows]
    )
    const totalRate = useMemo(
        () =>
            calculateTotal({
                data: finalRows,
                columnName: RowsField.Rate,
            }),
        [finalRows]
    )
    const totalRateD = useMemo(
        () =>
            calculateTotal({
                data: finalRows,
                columnName: RowsField.RateD,
            }),
        [finalRows]
    )
    const totalInwWt = useMemo(
        () =>
            calculateTotalWeight({
                data: finalRows,
                columnName: RowsField.InwCts,
            }),
        [finalRows]
    )
    const totalSaleWt = useMemo(
        () =>
            calculateTotalWeight({
                data: finalRows,
                columnName: RowsField.SaleCts,
            }),
        [finalRows]
    )
    const totalRejWt = useMemo(
        () =>
            calculateTotalWeight({
                data: finalRows,
                columnName: RowsField.RejCts,
            }),
        [finalRows]
    )
    const totalMixWt = useMemo(
        () =>
            calculateTotalWeight({
                data: finalRows,
                columnName: RowsField.MixCts,
            }),
        [finalRows]
    )
    const totalMfgWt = useMemo(
        () =>
            calculateTotalWeight({
                data: finalRows,
                columnName: RowsField.FinalStock,
            }),
        [finalRows]
    )
    const totalBalStock = useMemo(
        () =>
            calculateTotalWeight({
                data: finalRows,
                columnName: RowsField.BalStock,
            }),
        [finalRows]
    )

    const INITIAL_VISIBLE_COLUMNS = [
        RowsField.RoughCode,
        RowsField.RoughName,

        RowsField.Rate,
        RowsField.RateD,
        RowsField.InwCts,
        RowsField.SaleCts,
        RowsField.RejCts,
        RowsField.MixCts,
        RowsField.FinalStock,
        RowsField.BalStock,
        RowsField.BalAmt,
        RowsField.BalAmtD,

    ]
    const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

    let downloadDataFooter = {
        [RowsField.RoughCode]: "",
        [RowsField.RoughName]: "",

        [RowsField.Rate]: "Total: " + totalRate,
        [RowsField.RateD]: "Total: " + totalRateD,
        [RowsField.InwCts]: "Total: " + totalInwWt,
        [RowsField.SaleCts]: "Total: " + totalSaleWt,
        [RowsField.RejCts]: "Total: " + totalRejWt,
        [RowsField.MixCts]: "Total: " + totalMixWt,
        [RowsField.FinalStock]: "Total: " + totalMfgWt,
        [RowsField.BalStock]: "Total: " + totalBalStock,
        [RowsField.BalAmt]: "Total: " + totalStkAmt,
        [RowsField.BalAmtD]: "Total: " + totalStkAmtD,

    }
    const [dataFooter, setDataFooter] = useState(downloadDataFooter)
    useEffect(() => {
        if (finalRows && finalRows.length > 0 && initialColumn && initialColumn.length > 0) {
            const footerData = filterKeys(downloadDataFooter, initialColumn)
            setDataFooter(footerData)
        }

    }, [finalRows, initialColumn])



    const exportColumns = [

        {
            uid: [RowsField.RoughCode],
            name: "Code",
        },
        {
            uid: [RowsField.RoughName],
            name: "Name",
        },

        {
            uid: [RowsField.Rate],
            name: "Rate",
        },
        {
            uid: [RowsField.RateD],
            name: "Rate $",
        },
        {
            uid: [RowsField.InwCts],
            name: "Inw.Weight",
        },
        {
            uid: [RowsField.SaleCts],
            name: "Sale Weight",
        },
        {
            uid: [RowsField.RejCts],
            name: "Rej.Weight",
        },
        {
            uid: [RowsField.MixCts],
            name: "Mix Out",
        },
        {
            uid: [RowsField.FinalStock],
            name: "Manuf.Weight",
        },


        {
            uid: [RowsField.BalStock],
            name: "Stock Weight",
        },
        {
            uid: [RowsField.BalAmt],
            name: "Stock Amt",
        },
        {
            uid: [RowsField.BalAmtD],
            name: "Stock Amt($)",
        },

    ]

    const [exportData, setExportData] = useState(exportColumns)


    const [filterModel, setFilterModel] = useState({
        items: [],
    });

    const handleFilter = () => {
        funFilterData(filterDate.start, filterDate.end)
        setFilterModel({ items: [], })
    }

    const itemGridHeadClass = "report-grid-style"
    const numericOperators = getGridNumericOperators();

    const setColumnVisiblity = (column) => {
        if (initialColumn.includes(column))
            return true
        else return false
    }
    const [gridColumnFilter, setGridColumnFilter] = useState({});

    const getUniqueValues = (field) => {
        const values = new Set(data.map((row) => row[field])
            .filter(value => value !== undefined && value !== null && value !== '')
        );
        return [...values];
    };

    const handleColumnFilterChange = (e) => {
        const { value, name } = e.target
        setGridColumnFilter(prevState => ({
            ...prevState,
            [name]: value
        }))

    }
    const handleRemoveTag = (field, value) => {
        const updated = selectFilter[field].filter((v) => v !== value);

        handleSelectChange(field, updated);
        // ⬆️ same function Autocomplete uses to update states
    };
    // useEffect(() => {
    //     const fdata = [];

    //     const filtered = data.filter(item => {
    //         const isMatch = Object.entries(gridColumnFilter).every(([key, value]) => {
    //             if (value !== "") {
    //                 const filterValues = value.split(',').map(v => v.trim());
    //                 const itemValues = String(item[key] ?? "").split(',').map(v => v.trim());

    //                 // Check if any filter value exists in the item values
    //                 return filterValues.some(v => itemValues.includes(v));
    //             }
    //             return true; // if filter value is empty, don't filter by this key
    //         });
    //         // console.log(filtered)

    //         // Collect matched item if it passes the filter
    //         if (isMatch) {
    //             fdata.push(item);
    //         }

    //         return isMatch;
    //     });

    //     setRows(fdata)
    //         ;


    // }, [gridColumnFilter])

    const filteredUniqueValuesMap = useMemo(() => {
        const map = {};
        initialColumn?.forEach(col => {

            const field = col;
            console.log(field)
            const values = [...new Set(data.map(d => d[field]))];
            map[field] = values;
        });
        return map;
    }, [data, initialColumn]);

    const handleSelectChange = (field, values) => {
        setSelectFilter(prev => ({ ...prev, [field]: values }));
    };
    /* ---------- 3-STATE SORTING ---------- */
    const handleSort = (field) => {
        return () => {
            setSortConfig(prev => {
                if (prev.field !== field) return { field, order: "asc" };
                if (prev.order === "asc") return { field, order: "desc" };
                if (prev.order === "desc") return { field: null, order: null };
            });
        };
    };

    /* ---------- Filter Unique Values by Search ---------- */
    // const filteredUniqueValuesMap = useMemo(() => {
    //     const newMap = {};
    //     Object.entries(uniqueValuesMap).forEach(([field, values]) => {
    //         const s = debouncedSearch[field]?.toLowerCase() || "";
    //         newMap[field] = s
    //             ? values.filter(v => String(v).toLowerCase().includes(s))
    //             : values;
    //     });

    //     return newMap;
    // }, [uniqueValuesMap, debouncedSearch]);
    
    const renderHeadFilter = (name, headername) => {

        const field = name

        const sortIcon =
            sortConfig.field !== field ? <SortIconNone /> :
                sortConfig.order === "asc" ? <SortIconAsc /> :
                    sortConfig.order === "desc" ? <SortIconDesc /> :
                        <SortIconNone />;
        return (
            <Box sx={{ display: "flex", flexDirection: "column", padding: "2px" }}>

                {/* Title + Sort Button */}
                <Box className={` flex items-center justify-between `}
                    // sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    onClick={handleSort(field)}
                    style={{ cursor: "pointer" }}
                >
                    <div style={{ fontSize: "0.655rem" }} className=" w-full text-center flex   justify-center items-center leading-snug whitespace-normal h-7 overflow-hidden" >
                        {headername}
                    </div>
                    {sortIcon}
                </Box>

                <Autocomplete
                    multiple
                    size="small"
                    options={(filteredUniqueValuesMap[field] || []).filter(opt => opt != null)} // always fallback to empty array
                    value={selectFilter[field] || []}
                    onChange={(e, newValue) => handleSelectChange(field, newValue)}
                    disabled={!filteredUniqueValuesMap[field] || filteredUniqueValuesMap[field].length === 0}
                    noOptionsText="No options available"
                    renderTags={() => null}
                    slotProps={{
                        chip: {
                            size: "small",
                            sx: { height: 20, fontSize: "10px", padding: "0 4px", "& .MuiChip-label": { padding: 0 } }
                        },
                        input: { sx: { padding: "2px 0px !important", fontSize: "11px" } },
                        popper: { sx: { fontSize: "12px" } },
                        listbox: {
                            sx: {
                                fontSize: "11px",
                                "& .MuiAutocomplete-option": { padding: "2px 8px", minHeight: "28px" }
                            }
                        }
                    }}
                    sx={{
                        "& .MuiAutocomplete-inputRoot": { padding: "0px 4px !important", minHeight: "30px", background: "#FFFFFF" },
                        "& .MuiOutlinedInput-root": { padding: "0px !important", height: "30px" }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Search & Select"
                            variant="outlined"
                            size="small"
                            inputProps={{
                                ...params.inputProps, // ⚡ make sure inputProps exist
                                autoComplete: "off"
                            }}
                            sx={{
                                width: field === RowsField.RoughCode ? "110px" : field === RowsField.RoughName ? "130px" : "100px",
                                "& .MuiInputLabel-root": { fontSize: "11px", }
                            }}
                        />
                    )}
                />




            </Box>
        )
        // return (<Select
        //     name={name}
        //     selectionMode="multiple"
        //     onChange={(e) => handleColumnFilterChange(e)}
        //     variant="bordered"
        //     isVirtualized={true}
        //     showScrollIndicators={true}
        //     itemHeight={23}
        //     selectorIcon={<SelectorIcon />}
        //     value={gridColumnFilter[name]}
        //     classNames={{
        //         selectorIcon: "text-gray-700 text-xs",
        //         innerWrapper: "text-gray-50 ,border-1,p-5"
        //     }}
        //     disableSelectorIconRotation={true}
        //     size="sm"
        //     className={`${name == RowsField.RoughName ? "w-36" : "w-24"} bg-white text-xs`}
        // >
        //     {getUniqueValues(name).sort((a, b) => a > b ? 1 : -1).map((value) => (
        //         <SelectItem key={value}>
        //             <div style={{ fontSize: "0.7rem", whiteSpace: "nowrap", }}>  {value}</div>
        //         </SelectItem>
        //     ))}
        // </Select>)
    }
    const columns = [
        {
            field: RowsField.RoughCode,
            headerName: "Code",
            minWidth: 120,
            headerAlign: "center",
            flex: 1,
            align: 'center',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Code</div> */}
                    {renderHeadFilter(RowsField.RoughCode, "Code")}

                </Box>
            ),
        },
        {
            field: RowsField.RoughName,
            headerName: "Rough",
            minWidth: 150,
            headerAlign: "center",
            flex: 1,
            align: 'center',

            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Name</div> */}
                    {renderHeadFilter(RowsField.RoughName, "Name")}

                </Box>
            ),
        },
        {
            field: RowsField.Rate,
            headerName: "Rate",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            align: 'right',
            type: 'number',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Rate</div> */}
                    {renderHeadFilter(RowsField.Rate, "Rate")}

                </Box>
            ),
        },
        {
            field: RowsField.RateD,
            headerName: "Rate $",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            align: 'right',
            type: 'number',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Rate $</div> */}
                    {renderHeadFilter(RowsField.RateD, "Rate $")}

                </Box>
            ),
        },
        {
            field: RowsField.InwCts,
            headerName: "Inw.Weight",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            align: 'right',
            type: 'number',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Inw.Weight</div> */}
                    {renderHeadFilter(RowsField.InwCts, "Inw.Weight")}

                </Box>
            ),
        },
        {
            field: RowsField.SaleCts,
            headerName: "Sale Weight",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            align: 'right',
            type: 'number',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Sale Weight</div> */}
                    {renderHeadFilter(RowsField.SaleCts, "Sale Weight")}

                </Box>
            ),
        },
        {
            field: RowsField.RejCts,
            headerName: "Rej.Weight",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            type: 'number',
            align: 'right',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Rej.Weight</div> */}
                    {renderHeadFilter(RowsField.RejCts, "Rej.Weight")}

                </Box>
            ),
        },
        {
            field: RowsField.MixCts,
            headerName: "Mix out",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            type: 'number',
            align: 'right',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Mix Out</div> */}
                    {renderHeadFilter(RowsField.MixCts, "Mix Out")}

                </Box>
            ),
        },
        {
            field: RowsField.FinalStock,
            headerName: "Mfg.Weight",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            type: 'number',
            align: 'right',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Mfg.Weight</div> */}
                    {renderHeadFilter(RowsField.FinalStock, "Mfg.Weight")}

                </Box>
            ),
        },
        {
            field: RowsField.BalStock,
            headerName: "Stk Weight",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            type: 'number',
            align: 'right',
            headerClassName: itemGridHeadClass,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center whitespace-normal">Stock Weight</div> */}
                    {renderHeadFilter(RowsField.BalStock, "Stock Weight")}

                </Box>
            ),
        },
        {
            field: RowsField.BalAmt,
            headerName: "Stock Amt.",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            align: 'right',
            type: 'number',
            headerClassName: itemGridHeadClass,
            filterOperators: numericOperators,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Stock Amt</div> */}
                    {renderHeadFilter(RowsField.BalAmt, "Stock Amt")}

                </Box>
            ),
        },
        {
            field: RowsField.BalAmtD,
            headerName: "Amt ($)",
            minWidth: 105,
            headerAlign: "center",
            flex: 1,
            align: 'right',
            type: 'number',
            headerClassName: itemGridHeadClass,
            filterOperators: numericOperators,
            renderHeader: () => (
                <Box>
                    {/* <div className="text-center">Stock Amt($)</div> */}
                    {renderHeadFilter(RowsField.BalAmtD, "Stock Amt($)")}

                </Box>
            ),
        }
    ]


    useEffect(() => {
        if (CurrencySetting && CurrencySetting != "") {
            let AmtColumn = ""
            if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
                AmtColumn = [RowsField.RateD, RowsField.BalAmtD]
            else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
                AmtColumn = [RowsField.Rate.RowsField.RateD]
            else {
                setInitialColumn(INITIAL_VISIBLE_COLUMNS)
                setExportData(exportColumns)
                setDataFooter(downloadDataFooter)
            }

            if (AmtColumn != "") {
                const filterIniCol = initialColumn.filter(ele => !AmtColumn.includes(ele))
                const filterExpCol = exportColumns.filter((ele) => !AmtColumn.includes(ele.uid))
                //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
                const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => !AmtColumn.includes(ele))
                setExportData(filterExpCol)
                setInitialColumn(filterIniCol)
                setDataFooter(filterExpFooter)
            }
        }
    }, [CurrencySetting, data])

    const emptyRowField = Object.values(RowsField).reduce((acc, key) => {
        acc[key] = '';
        return acc;
    }, {});

    const getSelStockType = () => {
        if (selTradeOf == ENUM_TRADEOF_CODE.Polish)
            return ENUM_TRADEOF_TYPE.Polish
        else if (selTradeOf == ENUM_TRADEOF_CODE.Rough)
            return ENUM_TRADEOF_TYPE.Rough
        else if (selTradeOf == ENUM_TRADEOF_CODE.Rejection)
            return ENUM_TRADEOF_TYPE.Rejection
    }



    const exportExcel = () => {
        exportToExcel({
            data: finalRows,
            downloadFileName: "rough_wise_stock",
            exportColumns: exportData
        })
    }

    const exportPdf = () => {
        exportToPDF(
            {
                data: finalRows,
                downloadFileName: "Rough_Wise_Stock_Report",
                exportColumns: exportData,
                exportReportType: "MixStock",
                downloadFileheader: [{ key: "", value: compName.join(",") }],
                downloadDataFooter: dataFooter,
            })
    }

    function CustomFooter() {
        const apiRef = useGridApiContext();
        const visibleRowIds = apiRef.current.getSortedRowIds();

        // Sync scroll with DataGrid virtual scroller
        const [scrollLeft, setScrollLeft] = React.useState(0);

        // Width of real DataGrid column container
        const [containerWidth, setContainerWidth] = React.useState(0);
        const [scrollbarWidth, setScrollbarWidth] = React.useState(0);


        useEffect(() => {
            const width = window.innerWidth - document.documentElement.clientWidth;
            setScrollbarWidth(width || 0);
        }, []);

        // Track DataGrid horizontal scroll
        // Sync scroll with DataGrid body
        useEffect(() => {
            const scroller = document.querySelector('.MuiDataGrid-virtualScroller');
            if (!scroller) return;

            const handleScroll = () => setScrollLeft(scroller.scrollLeft);
            scroller.addEventListener("scroll", handleScroll);
            return () => scroller.removeEventListener("scroll", handleScroll);
        }, []);

        // Track DataGrid column container width (prevents footer cutoff)
        // Track exact DataGrid column container width
        useEffect(() => {
            const colContainer = document.querySelector('.MuiDataGrid-columnsContainer');
            if (!colContainer) return;

            const updateWidth = () => {
                setContainerWidth(colContainer.scrollWidth);
            };

            updateWidth();

            const observer = new ResizeObserver(updateWidth);
            observer.observe(colContainer);

            return () => observer.disconnect();
        }, []);

        // Build visible rows
        const visibleRows = React.useMemo(() => {
            return visibleRowIds.map((id) => apiRef.current.getRowWithUpdatedValues(id));
        }, [apiRef, visibleRowIds]);

        // Visible columns
        const VisibleCol = React.useMemo(() => {
            return apiRef.current.getAllColumns().filter((col) =>
                initialColumn.includes(col.field)
            );
        }, [apiRef]);

        // Totals
        const totals = React.useMemo(() => {
            const result = {};

            VisibleCol.forEach((col) => {
                if (col.type === "number") {
                    const sum = visibleRows.reduce((acc, row) => acc + (row[col.field] || 0), 0);

                    if ([RowsField.InwCts, RowsField.SaleCts, RowsField.RejCts, RowsField.MixCts].includes(col.field)) {
                        result[col.field] = sum.toFixed(3);
                    } else {
                        result[col.field] = sum.toFixed(2);
                    }
                } else {
                    result[col.field] = "";
                }
            });

            return result;
        }, [VisibleCol, visibleRows]);

        return (
            <Box className="w-full">
                {/* SCROLL-SYNCED TOTAL ROW */}
                <Box
                    display="flex"
                    width={containerWidth || "100%"}    // EXACT width of grid = no cutoff
                    position="relative"
                    left={-scrollLeft}                 // scroll sync
                    bgcolor="#ffffff"

                >
                    {VisibleCol.map((col) => (
                        <Box
                            key={col.field}
                            fontWeight="bold"
                            minWidth={col.minWidth}
                            textAlign="right"
                            fontSize="11px"
                            textTransform="uppercase"
                            flex={col.flex}
                        >
                            {col.type === "number" && (
                                <div className="p-1">
                                    <h6 style={{ margin: 0, padding: 2 }}>{col.headerName}</h6>
                                    {totals[col.field]}
                                </div>
                            )}
                        </Box>
                    ))}
                </Box>
                <GridPagination />
            </Box>
        );
    }
    const handleClearGridFilters = () => {
        setSelectFilter({})
        //funFilterData(stockType, selTradeOf, mixStockParams)
    }
    const getColName = (colName) => {
        if (columns && columns.length > 0) {
            const filData = columns.filter((ele) => ele.field == colName)
            if (filData && filData.length > 0) {
                return filData[0].headerName
            }
            else return colName
        }
        else return ""
    }
    if (isPending) {
        return <LoadingCard />
    }

    if (isError) {
        return <ErrorCard />
    }

    return (
        <div>
            <MainContainer pageName="Rough Stock" info={[]} breadcrumbs={["Stock", "Rough Stock"]}>
                <div className="flex w-full flex-col">

                    <div className="flex  flex-wrap items-center gap-2  mb-2">
                        <Card shadow="sm" radius="sm" className="mb-3 h-full">
                            <CardBody className="p-2">
                                <div className="flex flex-wrap items-center gap-2">
                                    {/* date */}
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"Start Date"}
                                            views={["day", "month", "year"]}
                                            format="DD/MM/YYYY"
                                            value={filterDate.start
                                                ? dayjs(filterDate.start)
                                                : filterDate.start}
                                            onChange={(newValue) => {
                                                setFilterDate((prev) => {
                                                    return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                                                })
                                            }}
                                            sx={{ width: "145px" }}
                                            slotProps={{ textField: { size: "small" } }}
                                        />
                                        <DatePicker
                                            label={"End Date"}
                                            views={["day", "month", "year"]}
                                            format="DD/MM/YYYY"
                                            value={filterDate.end
                                                ? dayjs(filterDate.end)
                                                : filterDate.end}
                                            onChange={(newValue) => {
                                                setFilterDate((prev) => {

                                                    return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                                                })
                                            }}
                                            slotProps={{ textField: { size: "small" } }}
                                            sx={{ width: "145px" }}
                                        />
                                    </LocalizationProvider>
                                    {/*  end of date */}

                                    <Button
                                        size="sm"
                                        color="primary"
                                        startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                                        onPress={handleFilter}
                                    //isLoading={isPending}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        size="sm"
                                        color="default"
                                        startContent={<FontAwesomeIcon icon={faRefresh} />}
                                        onPress={handleResetFilter}
                                        className={"bg-slate-700 text-white"}
                                    //isLoading={isPending}
                                    >
                                        Reset
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </div>

                </div>
                <div className="flex gap-5 justify-between mb-2">
                    {selectFilter && Object.keys(selectFilter).length > 0 ? <>
                        {/* <Chip onClick={handleClearGridFilters} size="sm" variant="bordered" className="cursor-pointer text-gray-700">
                <FontAwesomeIcon className="text-orange-600" icon={faFilterCircleXmark}></FontAwesomeIcon> Remove Filters</Chip> */}
                        <Chip icon={<FontAwesomeIcon style={{ fontSize: "12px", color: "#ff6a00" }}
                            icon={faFilterCircleXmark}></FontAwesomeIcon>} label=" Remove Filters"
                            onClick={handleClearGridFilters} size="small"
                            variant="outlined"
                            className="cursor-pointer text-gray-700"
                            sx={{
                                color: "#383737ff",
                                // Text color,
                                // borderColor: "#6e6e6eff",         // Border color
                                "& .MuiChip-label": {
                                    fontSize: "11px"
                                },
                                "& .MuiChip-icon": {
                                    marginLeft: "4px"
                                },
                            }}>
                        </Chip>

                    </>
                        : "-"}
                    <div className="gap-2  flex">
                        <Button size="sm" isDisabled={finalRows.length <= 0 ? true : false} color="success" onPress={exportExcel}>Export Excel</Button>
                        <Button size="sm" isDisabled={finalRows.length <= 0 ? true : false} color="danger" onPress={exportPdf}>Export PDF</Button>
                    </div>
                </div>
                <div className="mb-5" style={{ display: "flex", flexDirection: "row", gap: 4 }}>
                    {Object.entries(selectFilter).map(([field, values]) => (
                        <div key={field} style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                            <strong style={{ fontSize: "0.6rem" }} className="text-xs uppercase"> {values.length > 0 ? getColName(field) + " :" : ""} </strong>
                            {values.map(value => (
                                <Chip
                                    key={`${field}-${value}`}
                                    label={value}
                                    onDelete={() => handleRemoveTag(field, value)}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                    sx={{ height: 22, fontSize: "11px" }}
                                />
                            ))}
                        </div>
                    ))}
                </div>

                <Box sx={{ height: finalRows.length > 20 ? 500 : "auto", width: '100%' }}>
                    <DataGrid
                        rows={finalRows}
                        columns={columns}
                        columnHeaderHeight={70}
                        rowHeight={30}
                        disableColumnMenu={true}
                        disableColumnSorting={false}
                        initialState={data && data.length > 0 ? {
                            pagination: { paginationModel: { pageSize: 50, page: 0 } },
                        } : {}}
                        slots={data && data.length > 0 ? {
                            footer: CustomFooter,
                        } : {}}
                        getRowId={(row) => row.id}
                        // filterModel={filterModel}
                        //onFilterModelChange={handleFilterChange}
                        getRowClassName={(params) => {
                            if (params.id == 'total') {
                                return 'sticky-row';  // Add custom class to the last row
                            }
                            return 'row-class';
                        }}
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                                position: 'sticky',
                                top: 0,
                                zIndex: 1,
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold',
                            },
                            '& .sticky-row': {
                                position: 'sticky',
                                bottom: 0,
                                color: "#FFFFFF",
                                backgroundColor: '#424242f5',
                                zIndex: 10,
                                fontSize: "12px"
                            },
                            '& .row-class:hover': {
                                backgroundColor: '#ffeabc',
                            },
                            '& .row-class': {
                                fontSize: '11px',
                                background: "#FFFFFF",
                            },
                            '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': {
                                display: 'none',
                            },
                            '& .MuiDataGrid-columnHeader .MuiDataGrid-iconSeparator': {
                                display: 'none',
                            },
                            '& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer': {
                                display: 'none',
                            },
                            '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
                                paddingLeft: 0,
                                paddingRight: 0,
                                marginLeft: 0,
                                marginRight: 0,
                            },
                            '& .MuiDataGrid-columnHeaderDraggableContainer': {
                                backgroundColor: "#eceff1"
                            },
                            // '& .MuiDataGrid-footerContainer': {
                            //     backgroundColor: "#f1f1f1ff"
                            // }

                        }}
                        columnVisibilityModel={{
                            [RowsField.BalAmt]: CurrencySetting != ENUM_CURRENCY_SETTING_VAL.Dollar ? true : false,
                            [RowsField.BalAmtD]: CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS ? true : false,
                            [RowsField.Rate]: CurrencySetting != ENUM_CURRENCY_SETTING_VAL.Dollar ? true : false,
                            [RowsField.RateD]: CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS ? true : false,
                        }}
                    />
                </Box>

            </MainContainer>
        </div>
    )
}

export default RoughStock

